import { FC, MouseEventHandler } from 'react';
import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Nullable } from 'common-types';
import ConnectionsContainer from '../../connections/containers/ConnectionsContainer';
import UpdateConnectionContainer from '../../connections/containers/ConnectionModalContainer';
import { Organization } from '../../organizations/organization-types';

const ConnectionSettingsTab: FC<
  React.PropsWithChildren<ConnectionSettingsTabProps>
> = props => {
  const { classes } = useStyles();
  const { chosenOrganization, isUserAdminRole } = props;

  if (chosenOrganization === null) {
    return null;
  }

  return (
    <div className={classes.orgSettingsTab}>
      <UpdateConnectionContainer />
      <ConnectionsContainer isUserAdminRole={isUserAdminRole} />
    </div>
  );
};

interface ConnectionSettingsTabProps {
  chosenOrganization: Nullable<Organization>;
  isUserAdminRole: boolean;
  showRemoveOrgModal: MouseEventHandler<HTMLButtonElement>;
}

const useStyles = makeStyles()((theme: Theme) => ({
  orgSettingsTab: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },
  fields: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    width: '50%',
    [theme.breakpoints.down('lg')]: {
      width: '100%',
    },
  },
}));

export default ConnectionSettingsTab;
